
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoShipAddressGrid extends Serenity.EntityGrid<PoShipAddressRow, any> {
        protected getColumnsKey() { return PoShipAddressColumns.columnsKey; }
        protected getDialogType() { return PoShipAddressDialog; }
        protected getIdProperty() { return PoShipAddressRow.idProperty; }
        protected getInsertPermission() { return PoShipAddressRow.insertPermission; }
        protected getLocalTextPrefix() { return PoShipAddressRow.localTextPrefix; }
        protected getService() { return PoShipAddressService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}